(() => {
  if (customElements.get('sj-contextual-products')) return;
  class ContextualProducts extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.timers = new Map();
      this.seen = new WeakSet();
      this.onSubmit = (event) => this.add(event);
      this.onClick = (event) => {
        const link = event.target.closest('a[href*="/products/"]');
        if (link) this.track('sj_recommendation_click', link.closest('[data-sj-discovery-card]'));
      };
      this.onConsent = () => this.observe();
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
      document.addEventListener('visitorConsentCollected', this.onConsent);
      document.addEventListener('visibilitychange', this.onConsent);
      this.observe();
    }
    allowed() {
      try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
      catch { return false; }
    }
    track(event, card) {
      if (!card || !this.allowed()) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event, placement: this.dataset.placement, intent: this.dataset.intent,
          page_handle: this.dataset.pageHandle, page_language: document.documentElement.lang,
          item_handle: card.dataset.productHandle, item_brand: card.dataset.vendor,
          item_variant: card.dataset.variantId, currency: card.dataset.currency,
          value: Number(card.dataset.price), quantity: 1});
        if (typeof window.clarity === 'function') window.clarity('event', event);
      } catch {}
    }
    observe() {
      this.observer?.disconnect();
      this.timers.forEach(clearTimeout);
      this.timers.clear();
      if (!this.allowed() || document.hidden || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(({target, intersectionRatio}) => {
          if (this.seen.has(target)) return;
          if (intersectionRatio >= 0.5 && !this.timers.has(target)) {
            this.timers.set(target, setTimeout(() => {
              this.timers.delete(target);
              if (!this.allowed() || document.hidden || !target.isConnected) return;
              this.seen.add(target);
              this.track('sj_recommendation_impression', target);
              this.observer.unobserve(target);
            }, 1000));
          } else if (intersectionRatio < 0.5) {
            clearTimeout(this.timers.get(target));
            this.timers.delete(target);
          }
        });
      }, {threshold: [0, 0.5]});
      this.querySelectorAll('[data-sj-discovery-card]').forEach(card => {
        if (!this.seen.has(card)) this.observer.observe(card);
      });
    }
    async add(event) {
      const form = event.target.closest('[data-sj-discovery-form]');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      const button = form.querySelector('button');
      if (button.disabled) return;
      const card = form.closest('[data-sj-discovery-card]');
      const success = card.querySelector('[data-sj-discovery-success]');
      const error = card.querySelector('[data-sj-discovery-error]');
      success.hidden = true;
      error.hidden = true;
      button.disabled = true;
      this.track('sj_recommendation_add_attempt', card);
      try {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json'}, body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok || !result.id) throw new Error('add_failed');
        success.hidden = false;
        this.track('sj_recommendation_add_success', card);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const cartResponse = await fetch(`${root}cart.js`, {credentials: 'same-origin'});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.cart-count').forEach(count => {
              count.textContent = count.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : cart.item_count;
            });
          }
        } catch {}
      } catch {
        error.hidden = false;
        this.track('sj_recommendation_add_failure', card);
      } finally { button.disabled = false; }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.timers.forEach(clearTimeout);
      this.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('visitorConsentCollected', this.onConsent);
      document.removeEventListener('visibilitychange', this.onConsent);
      this.ready = false;
    }
  }
  customElements.define('sj-contextual-products', ContextualProducts);
})();
